import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllTiktokInfluencersV2.graphql';
import { Query, QueryallTiktokInfluencersV2Args } from '../../__generated__/globalTypes';

export const useAllTiktokInfluencersV2Query = (options?: QueryHookOptions<Query, QueryallTiktokInfluencersV2Args>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallTiktokInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllTiktokInfluencersV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallTiktokInfluencersV2Args>
): QueryResult<Query, QueryallTiktokInfluencersV2Args> & {
  getAllTiktokInfluencersV2: LazyQueryExecFunction<Query, QueryallTiktokInfluencersV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllTiktokInfluencersV2, result] = useLazyQuery<Query, QueryallTiktokInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllTiktokInfluencersV2, ...result };
};

export const useAllTiktokInfluencersV2PromiseQuery = () => {
  const client = useApolloClient();

  const getAllTiktokInfluencersV2 = useCallback(
    (options?: Omit<QueryOptions<QueryallTiktokInfluencersV2Args, Query>, 'query'>) =>
      client.query<Query, QueryallTiktokInfluencersV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllTiktokInfluencersV2 };
};
// Suspense Query Hooks
export const useAllTiktokInfluencersV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallTiktokInfluencersV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryallTiktokInfluencersV2Args>(QUERY, {
    ...options
  });

  return result;
};
